import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorBillingNitService {

  private URL = environment.api + "api/erp/inventory/vendor-billing";
  constructor(
    private http: HttpClient
  ) { }

  getVendorBillingNitById(vendorId:number) {
    return this.http.get(this.URL + '/' + vendorId);
  }

  getVendorBillingNitByIdValidateAdministrative(vendorId:number) {
    return this.http.get(this.URL + '/validate/' + vendorId);
  }
  
}
